class statisticsInvStateDetailCtrl {
    constructor($scope, httpRequest, treeSelectService) {
        // 字典数据
        $scope.dictData = {}
        const typecodeArrStr = '["inv_type"]'
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })

        const invObj = JSON.parse(localStorage.getItem('stateStatisticsDetail'))
        $scope.invObj = invObj
        // 下拉开票点
        $scope.queryUkeyConfig = {
            queryName: 'ukeyName',
            queryKey: 'ukeyId',
            queryType: 'Flater',
            parentIdName: 'parentUkeyId',
            multiple: true,
            parentId: 0,
            defaultSelect: [],
        }
        $scope.reset = function () {
            $scope.queryUkeyConfig.defaultSelect = []
        }
        $scope.param = {
            pageNum: 0,
            pageSize: 10,
            param: {
                invType: invObj.invType,
                invoiceCodeNumber: '',
                invoiceDateMax: invObj.invoiceDateMax,
                invoiceDateMin: invObj.invoiceDateMin,
                orgIdList: [invObj.orgId],
                ukeyIdList: [],
                accessToken: localStorage.id_token,
            },
        }


        httpRequest.post_qryUkeyListOfOrgIds($scope.param.param.orgIdList).then((res) => {
            if (res.data.success) {
                $scope.ukeyList = treeSelectService(res.data.value, 'ukeyId', 'ukeyName')
            }
        })

        $scope.ukeySelectChange = function ukeySelectChange(v) {
            const ukeySelectArr = v
            const ukeySelectL = ukeySelectArr.length
            if (ukeySelectL > 0) {
                $scope.param.param.ukeyIdList = ukeySelectArr.map((item) => item.ukeyId)
            } else {
                $scope.param.param.ukeyIdList = []
            }
        }

        // 导出
        $scope.exportInvoic = function exportInvoic() {
            httpRequest.get_exportInvoiceStatusUkeyToXLS($scope.param.param)
        }
        function countResult(list) {
            let preRow = list.shift()
            const counts = {}
            // 开票点下月份数
            counts[preRow.ukeyId] = 1
            // 月份下发票种类数
            counts[`${preRow.ukeyId}${preRow.invoiceMonth}`] = 1
            do {
                const listItem = list.shift()
                if (listItem.ukeyId === preRow.ukeyId) {
                    if (listItem.invoiceMonth !== preRow.invoiceMonth) {
                        // month + 1
                        counts[listItem.ukeyId] += 1
                        // 该月份下发票种类数初始化 1
                        counts[`${listItem.ukeyId}${listItem.invoiceMonth}`] = 1
                    } else if (listItem.invType !== preRow.invType) {
                        counts[`${listItem.ukeyId}${listItem.invoiceMonth}`] += 1
                    }
                } else {
                    // 开票点下月份数
                    counts[listItem.ukeyId] = 1
                    // 月份下发票种类数
                    counts[`${listItem.ukeyId}${listItem.invoiceMonth}`] = 1
                }
                preRow = listItem
            } while (list.length > 0)
            return counts
        }

        function getRowsapns(list) {
            let preRow = list.shift()
            const rowspan = {}
            rowspan[preRow.ukeyId] = 1
            rowspan[`${preRow.ukeyId}${preRow.invoiceMonth}`] = 1
            while (list.length > 0) {
                const listItem = list.shift()
                if (!$scope.isShowThisRow(listItem)) {
                    continue
                }
                if (listItem.ukeyId === preRow.ukeyId) {
                    rowspan[listItem.ukeyId] += 1
                    if (listItem.invoiceMonth === preRow.invoiceMonth) {
                        rowspan[`${listItem.ukeyId}${listItem.invoiceMonth}`] += 1
                    } else {
                        rowspan[`${listItem.ukeyId}${listItem.invoiceMonth}`] = 1
                    }
                } else {
                    rowspan[listItem.ukeyId] = 1
                    rowspan[`${listItem.ukeyId}${listItem.invoiceMonth}`] = 1
                }
                preRow = listItem
            }
            return rowspan
        }
        $scope.getMonthRowspan = function getMonthRowspan(item) {
            return $scope.rowspans[`${item.ukeyId}${item.invoiceMonth}`]
        }

        $scope.getUkeyRowspan = function getUkeyRowspan(item) {
            return $scope.rowspans[item.ukeyId]
        }
        $scope.isShowThisRow = function isShowThisRow(item) {
            const monthCount = $scope.counts[item.ukeyId]
            const invTypeCount = $scope.counts[`${item.ukeyId}${item.invoiceMonth}`]

            if (item.invType === '9999999' && invTypeCount === 2) {
                return false
            }
            // 只选了一个月不显示月小计行
            if (monthCount === 2 && item.invoiceMonth === '9999999') {
                return false
            }
            return true
        }
        $scope.isShowThisUkey = function isShowThisUkey(item, index) {
            if (index === 0) {
                return true
            }
            const preRow = $scope.listData[index - 1]
            return preRow.ukeyId !== item.ukeyId
        }

        $scope.isShowThisMonth = function isShowThisMonth(item, index) {
            if (index === 0) {
                return true
            }
            const preRow = $scope.listData[index - 1]
            return preRow.ukeyId !== item.ukeyId
                || preRow.invoiceMonth !== item.invoiceMonth
        }
        $scope.queryList = function queryList() {
            httpRequest.post_qryBiInvoiceStatusQryOrgList($scope.param).then((res) => {
                $scope.listData = res.data.value.list
                if ($scope.listData.length === 0) {
                    return
                }
                $scope.counts = countResult($scope.listData.slice())
                $scope.rowspans = getRowsapns($scope.listData.slice())
            })
        }
        $scope.queryList()
    }
}
statisticsInvStateDetailCtrl.$inject = ['$scope', 'httpRequest', 'treeSelectService']
export default statisticsInvStateDetailCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/outputStatistics/statisticsInvState/statisticsInvStateDetailCtrl.js